import React from 'react';
import {TabsWrapper} from './styles';
import {TabLink} from '../';

export default ({
  dataArray,
  url,
  wBadge,
  onClick,
  dataCy,
}: {
  dataArray: Array<any>;
  url?: string;
  wBadge?: true;
  onClick?: any;
  dataCy?: string;
}) => (
  <TabsWrapper data-cy={dataCy}>
    {wBadge ? (
      <>
        {dataArray.map((el, idx) => {
          return (
            <TabLink
              key={idx}
              title={el.title}
              wBadge={wBadge}
              numBadge={el?.numBadge || 0}
              active={el.active}
              onClick={() => onClick(el.title)}
            />
          )
        })}
      </>
    ) : (
      <>
        {dataArray.map((el, idx) => {
          return (
            <TabLink key={idx} title={el.title} path={`${url}/${el.url}`} onClick={onClick && onClick} />
          )
        })}
      </>
    )}
  </TabsWrapper>
);
